
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import Editor from '@tinymce/tinymce-vue';
import Store from '@/store/index';
import AppConst from '@/lib/appConst';
import common from '@/lib/common';
import Brand from '@/store/entities/baseInfo/Brand';
import Product from '@/store/entities/baseInfo/Product';

@Component
export default class EditBrand extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: String, default: "Create" }) editMode: string;
    @Prop({ type: Object, default: new Product() }) product: Product;

    authMode: string = "个人授权";

    ok() {
        this.$emit('on-ok', this.authMode);
        this.$emit('input', false);
    }

    cancel() {
        this.$emit('input', false);
    }

    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        }
    }

    handleAuthModeChange(e) {
        this.authMode = e;
    }
}
